/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
// import { useLang } from "_metronic/i18n";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

// CUSTOM IMPORTS
import { checkIsActive, checkIsActiveForChildren } from "../../../../_helpers";
import * as criteriaService from "../../../../../services/Criteria";
import * as criteriaQuestionService from "../../../../../services/CriteriaQuestion";
import {
  GradeApplicationStatus,
  HtmlInputTypes,
} from "../../../../../app/utils/constants";
import {
  hasRight,
  isBorderOperator,
  isEcologyOperator,
  isEmergencyOperator,
  isInstitution,
  isInternalAffairsOperator,
  isNationalParkOperator,
} from "app/modules/StakeholderCabinet/utils";

import "./asidemenu.scss";

export function AsideMenuList({ layoutProps, setCurrentBreadcrumb }) {
  const location = useLocation();
  const intl = useIntl();
  // const locale = useLang();
  const { currentStakeholder } = useSelector((state) => state.stakeholder);

  // //breadcrumb test
  // const handleLinkClick = (id) => {
  //   setCurrentBreadcrumb(id);
  // };

  const { gradeApplication, selectedGrade } = useSelector(
    (state) => state.gradeApplication
  );

  // const { person } = useSelector((state) => state.login);
  const [multiSelectFileValues, setMultiSelectFileValues] = useState({});
  const [totalP, setTotalP] = useState(null);

  const getMenuItemActive = (url, hasSubmenu = false, childUrls = null) => {
    // For submenus, check if any child URL is active
    let isActive = false;

    if (hasSubmenu && childUrls && Array.isArray(childUrls)) {
      // For parent menus with children, check if any child is active
      isActive = checkIsActiveForChildren(location, childUrls);
    } else {
      // For regular menu items, check the exact URL
      isActive = checkIsActive(location, url);
    }

    if (isActive) {
      return hasSubmenu
        ? " menu-item-open menu-item-here "
        : " menu-item-active ";
    }
    return "";
  };
  // const checkIsInstitution = (structureName) => {
  //   return structureNameList.some((i) => i.structureName === structureName);
  // };
  useEffect(() => {
    if (!isInstitution()) {
      (async function init() {
        try {
          const criterias =
            selectedGrade && currentStakeholder.industryCategory?._id
              ? await criteriaService.getCriteriasByIndustryCategoryId(
                  currentStakeholder.industryCategory?._id,
                  selectedGrade
                )
              : {};
          const criteriaQuestions = currentStakeholder.industrySubCategory?._id
            ? await criteriaQuestionService.getCriteriaQuestionsByIndustrySubCategory(
                currentStakeholder.industrySubCategory?._id
              )
            : {};

          if (!criterias?.data || !criteriaQuestions?.data) {
            return;
          }
          const initialValues = {};
          if (gradeApplication !== null && gradeApplication.length > 0) {
            for (let i = 0; i < gradeApplication.length; i++) {
              if (
                gradeApplication[i].status ===
                  GradeApplicationStatus.ACCEPTED ||
                gradeApplication[i].status === GradeApplicationStatus.EDITED
              ) {
                let gradeApp = gradeApplication[i];
                for (let quest of criteriaQuestions.data) {
                  if (quest.htmlType === HtmlInputTypes.TABLE) {
                    initialValues[quest._id] = {
                      answers: [],
                      tableType: undefined,
                    };
                  }
                  if (quest.htmlType === HtmlInputTypes.MULTISELECT_FILES) {
                    multiSelectFileValues[quest._id] = {};
                  }
                  const item = gradeApp?.questions.find(
                    (q) => q.criteriaQuestion._id === quest._id
                  );
                  initialValues[quest._id] =
                    item?.value !== "" ? item?.value : "";
                }
              }
            }
          } else {
            for (let quest of criteriaQuestions.data) {
              if (
                quest.htmlType === HtmlInputTypes.TRANSLATABLE ||
                quest.htmlType === HtmlInputTypes.TEXTAREA
              ) {
                initialValues[quest._id] = { az: "" };
              } else if (quest.htmlType === HtmlInputTypes.TABLE) {
                initialValues[quest._id] = {
                  // value: [],
                  // country: {}
                  answers: [],
                  tableType: undefined,
                };
              } else if (quest.htmlType === HtmlInputTypes.NESTED_QUESTION) {
                initialValues[quest._id] = {};
              } else if (quest.htmlType === HtmlInputTypes.MULTISELECT_FILES) {
                initialValues[quest._id] = {
                  options: [],
                  files: [],
                };
              } else {
                initialValues[quest._id] = "";
              }
            }
          }
          const { questionValues, pointCalcResult } = getCalcResult(
            criterias.data,
            criteriaQuestions.data
          );
          const question = criteriaQuestions.data;
          const criteriaList = criterias.data;

          let totalEarnedPoints = 0;
          let maxEarnablePoints = 0;

          for (let criteria of pointCalcResult) {
            totalEarnedPoints += criteria.earned;
            maxEarnablePoints += criteria.total;

            const total = (totalEarnedPoints / maxEarnablePoints) * 10;
            const fix = total.toFixed();

            setTotalP(fix);
          }
        } catch (err) {
          console.log("Error: ", err);
        }
      })();
    }
  }, []);

  const getCalcResult = (criterias, criteriaQuestions) => {
    const values = {};
    for (let quest of gradeApplication[gradeApplication.length - 1].questions) {
      // gradeApplication.length - 1
      if (quest.nestedValues === null) {
        values[quest.criteriaQuestion._id] = quest.value;
      }
    }

    let finalResultObject = [];
    for (let criteria of criterias) {
      const criteriaGroup = {
        _id: criteria._id,
        name: criteria.name,
        total: 0,
        earned: 0,
      };

      const questionGroup = criteriaQuestions.filter(
        (question) => question.criteria._id === criteria._id
      );

      criteriaGroup.total = questionGroup.reduce(
        (total, current) => total + current.point,
        0
      );
      criteriaGroup.earned = questionGroup.reduce((total, current) => {
        if (values[current._id] !== "" && values[current._id] !== undefined) {
          if (
            values[current._id][intl.locale] !== "" ||
            values[current._id][intl.locale] !== undefined
          ) {
            return total + current.point;
          } else {
            return total + 0;
          }
        } else {
          return total + 0;
        }
      }, 0);

      finalResultObject.push(criteriaGroup);
    }

    let finalValue = Object.assign({ ...values }, []);

    const questionValues = { ...finalValue };
    const pointCalcResult = [...finalResultObject];

    return { questionValues, pointCalcResult };
  };

  const goToPage = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* <div className="text-center" style={{ paddingTop: 10 }}>
        <p style={{ marginBottom: 0 }}>{currentStakeholder?.name}</p>
        {!isInstitution() && (
          <p style={{ marginTop: 0 }}>
            <FormattedMessage id="industryCategory" />:{" "}
            {currentStakeholder?.industryCategory?.name[locale]}
          </p>
        )}
      </div> */}
      <ul className={`menu-nav${layoutProps.ulClasses}`}>
        <li className="aside_top"></li>
        {/* MAIN */}
        <li
          // style={{ marginBottom: '50px' }}
          className={`menu-item ${getMenuItemActive(
            "/stakeholder/cabinet/home",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/stakeholder/cabinet/home">
            <i
              style={{ fontSize: "22px", marginRight: "10px" }}
              className="menu-bullet menu-bullet-dot"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 12H3L12 3L21 12H19"
                  stroke="#585F74"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 12V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V12"
                  stroke="#585F74"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 21V15C9 13.8954 9.89543 13 11 13H13C14.1046 13 15 13.8954 15 15V21"
                  stroke="#585F74"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </i>
            <span className="menu-text">
              <FormattedMessage id="menu_dashboard" />
            </span>
          </NavLink>
        </li>
        <li className="aside-line"></li>

        {!isBorderOperator() &&
        !isEcologyOperator() &&
        !isNationalParkOperator() &&
        !isEmergencyOperator() &&
        !isInternalAffairsOperator() ? (
          <>
            {/* Electron Services */}
            <li className="menu-section ">
              <h4
                className="menu-text"
                style={{ textTransform: "none", fontSize: "1.1em" }}
              >
                <FormattedMessage id="menu_e-services" />
              </h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            {/* EVENTS */}
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/stakeholder/cabinet/events",
                true,
                [
                  "/stakeholder/cabinet/events",
                  "/stakeholder/cabinet/application",
                  "/stakeholder/cabinet/general-information",
                  "/stakeholder/cabinet/selection-rules",
                ]
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/stakeholder/cabinet/events"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M11.795 21H5C3.89543 21 3 20.1046 3 19V7C3 5.89543 3.89543 5 5 5H17C18.1046 5 19 5.89543 19 7V11"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="18"
                      cy="18"
                      r="4"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 3V7"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M7 3V7"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 11H19"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18 16.4961V18.0001L19 19.0001"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_measure" />
                </span>
                <i className="menu-arrow" />
              </NavLink>

              <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/events"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/events"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="4"
                            stroke="#585F74"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="menu.all_events" />
                      </span>
                    </NavLink>
                  </li>
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/application"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/application"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="4"
                            stroke="#585F74"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="gradeApplication" />
                      </span>
                    </NavLink>
                  </li>
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/general-information"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/general-information"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="4"
                            stroke="#585F74"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="general.info" />
                      </span>
                    </NavLink>
                  </li>
                  {/* <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/terms-of-participation"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/terms-of-participation"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="4" stroke="#585F74" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </i>
                      <span className="menu-text">

                        <FormattedMessage id="term.of.participation" />
                      </span>
                    </NavLink>
                  </li> */}
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/selection-rules"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/selection-rules"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="4"
                            stroke="#585F74"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="events.hero.selection_rules" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            {/* PERMISSIONS */}
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/stakeholder/cabinet/permission",
                true,
                [
                  "/stakeholder/cabinet/permission",
                  "/stakeholder/cabinet/tato-permission",
                ]
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/stakeholder/cabinet/permission"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9 12L11 14L15 10"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M11.9999 3C14.3357 5.06658 17.3843 6.14257 20.4999 6C21.4163 9.11753 21.0293 12.4734 19.4273 15.3005C17.8253 18.1276 15.1452 20.1842 11.9999 21C8.8545 20.1842 6.17447 18.1276 4.57246 15.3005C2.97044 12.4734 2.58342 9.11753 3.49986 6C6.61539 6.14257 9.66403 5.06658 11.9999 3"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_permission" />
                </span>
                <i className="menu-arrow" />
              </NavLink>
              <div className="menu-submenu ">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  {hasRight("get_guide_permission_documents_list") && (
                    <li
                      className={`menu-item item-submenu ${getMenuItemActive(
                        "/stakeholder/cabinet/permission/my-permission-list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/stakeholder/cabinet/permission/my-permission-list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="4"
                              stroke="#585F74"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="menu.my_permission" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {hasRight("create_guide_permission_document") && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/stakeholder/cabinet/permission/create"
                      )}`}
                      aria-haspopup="true"
                      onClick={() => localStorage.removeItem("docId")}
                    >
                      <NavLink
                        className="menu-link"
                        // to="/stakeholder/cabinet/permission/create"
                        to="#"
                        onClick={() =>
                          goToPage(`/stakeholder/cabinet/permission/create`)
                        }
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="4"
                              stroke="#585F74"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="menu.create_permission" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {hasRight("get_ta_to_permission_documents_list") && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/stakeholder/cabinet/tato-permission/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/stakeholder/cabinet/tato-permission/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="4"
                              stroke="#585F74"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="menu.list_tato_permission" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {hasRight("create_ta_to_permission_document") && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/stakeholder/cabinet/tato-permission/create"
                      )}`}
                      aria-haspopup="true"
                      onClick={() => localStorage.removeItem("tatoDocId")}
                    >
                      <NavLink
                        className="menu-link"
                        to="/stakeholder/cabinet/tato-permission/create"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="4"
                              stroke="#585F74"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </i>
                        <span className="menu-text">
                          <FormattedMessage id="menu.create_tato_permission" />
                        </span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>

            {/* TRAININGS */}
            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/trainings",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink
                className="menu-link"
                to="/stakeholder/cabinet/trainings"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M22 9L12 5L2 9L12 13L22 9V15"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6 10.6001V16.0001C6 17.657 8.68629 19.0001 12 19.0001C15.3137 19.0001 18 17.657 18 16.0001V10.6001"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_training" />
                </span>
              </NavLink>
            </li>

            {/* CONSULTATIONS */}
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/stakeholder/cabinet/consulting",
                true,
                [
                  "/stakeholder/cabinet/my_consulting",
                  "/stakeholder/cabinet/consulting",
                ]
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink
                className="menu-link menu-toggle"
                to="/stakeholder/cabinet/my_consulting"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      cx="10"
                      cy="10"
                      r="7"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="10"
                      cy="10"
                      r="7"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M21 21L15 15"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10 12.9999V13.0099"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99986 10.0001C10.6935 10.0004 11.2969 9.52511 11.4591 8.85066C11.6212 8.17621 11.2997 7.47857 10.6817 7.16361C10.0637 6.84866 9.31028 6.99854 8.85986 7.52608"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.99986 10.0001C10.6935 10.0004 11.2969 9.52511 11.4591 8.85066C11.6212 8.17621 11.2997 7.47857 10.6817 7.16361C10.0637 6.84866 9.31028 6.99854 8.85986 7.52608"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_consultation_request" />
                </span>
                <i className="menu-arrow" />
              </NavLink>

              <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/my_consulting",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/my_consulting"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="4"
                            stroke="#585F74"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="menu.my_request" />
                      </span>
                    </NavLink>
                  </li>
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/stakeholder/cabinet/consulting/new",
                      false
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/stakeholder/cabinet/consulting/new"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="4"
                            stroke="#585F74"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </i>
                      <span className="menu-text">
                        <FormattedMessage id="menu.new_request" />
                      </span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            <li className="aside-line"></li>

            <li className="menu-section ">
              <h4
                className="menu-text"
                style={{ textTransform: "none", fontSize: "1.1em" }}
              >
                <FormattedMessage id="menu_local_partners" />
              </h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/partners/operators",
                false
              )}`}
              aria-haspopup="true"
            >
              <a
                className="menu-link"
                href={
                  process.env.REACT_APP_ENV === "production"
                    ? "https://data.tourism.gov.az/stakeholders/industry/2"
                    : "https://dev-data.tourism.gov.az/stakeholders/industry/2"
                }
                target={
                  process.env.REACT_APP_ENV === "production"
                    ? "_blank"
                    : "_self"
                }
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M15 5V7"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 11V13"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 17V19"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5 5H19C20.1046 5 21 5.89543 21 7V10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10V7C3 5.89543 3.89543 5 5 5"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_tour_operator_travel" />
                </span>
              </a>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/partners/hotels",
                false
              )}`}
              aria-haspopup="true"
            >
              <a
                className="menu-link"
                href={
                  process.env.REACT_APP_ENV === "production"
                    ? "https://data.tourism.gov.az/stakeholders/industry/1"
                    : "https://dev-data.tourism.gov.az/stakeholders/industry/1"
                }
                target={
                  process.env.REACT_APP_ENV === "production"
                    ? "_blank"
                    : "_self"
                }
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M3 21H21"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 8H10"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 12H10"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 12H10"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 16H10"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 16H10"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 8H15"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 8H15"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 12H15"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 12H15"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 16H15"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 16H15"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_hotels" />
                </span>
              </a>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/partners/guides",
                false
              )}`}
              aria-haspopup="true"
            >
              <a
                className="menu-link"
                href={
                  process.env.REACT_APP_ENV === "production"
                    ? "https://data.tourism.gov.az/stakeholders/industry/3"
                    : "https://dev-data.tourism.gov.az/stakeholders/industry/3"
                }
                target={
                  process.env.REACT_APP_ENV === "production"
                    ? "_blank"
                    : "_self"
                }
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 18V3L19 7L12 11"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 17.6699C8.38 18.0299 8 18.4899 8 18.9999C8 20.0999 9.8 20.9999 12 20.9999C14.2 20.9999 16 20.0999 16 18.9999C16 18.4999 15.62 18.0299 15 17.6699"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 17.6699C8.38 18.0299 8 18.4899 8 18.9999C8 20.0999 9.8 20.9999 12 20.9999C14.2 20.9999 16 20.0999 16 18.9999C16 18.4999 15.62 18.0299 15 17.6699"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_guides" />
                </span>
              </a>
            </li>

            <li className="aside-line"></li>

            <li className="menu-section ">
              <h4
                className="menu-text"
                style={{ textTransform: "none", fontSize: "1.1em" }}
              >
                <FormattedMessage id="other" />
              </h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/reporting",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink
                className="menu-link"
                to="/stakeholder/cabinet/reporting"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      x="10"
                      y="9"
                      width="4"
                      height="12"
                      rx="1.105"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="10"
                      y="9"
                      width="4"
                      height="12"
                      rx="1.105"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="17"
                      y="3"
                      width="4"
                      height="18"
                      rx="1.105"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="17"
                      y="3"
                      width="4"
                      height="18"
                      rx="1.105"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="5"
                      cy="19"
                      r="2"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_reporting" />
                </span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/email",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/stakeholder/cabinet/email">
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      x="3"
                      y="5"
                      width="18"
                      height="14"
                      rx="2"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="3"
                      y="5"
                      width="18"
                      height="14"
                      rx="2"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 7L12 13L21 7"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu_email" />
                </span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/tourism-map",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink
                className="menu-link"
                to="/stakeholder/cabinet/tourism-map"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M18 5.99988V6.00988"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18 13L14.5 7.99997C13.5691 6.31749 13.967 4.21072 15.4475 2.98372C16.928 1.75673 19.072 1.75673 20.5525 2.98372C22.0329 4.21072 22.4309 6.31749 21.5 7.99997L18 13"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.5 4.75L9 4L3 7V20L9 17L15 20L21 17V15"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.5 4.75L9 4L3 7V20L9 17L15 20L21 17V15"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 4V17"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9 4V17"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 15V20"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15 15V20"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu.improve.tourism" />
                </span>
              </NavLink>
            </li>

            <li
              className={`menu-item ${getMenuItemActive(
                "/stakeholder/cabinet/certificate",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink
                className="menu-link"
                to="/stakeholder/cabinet/certificate"
              >
                <i
                  style={{ fontSize: "22px", marginRight: "10px" }}
                  className="menu-bullet menu-bullet-dot"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14 3V7C14 7.55228 14.4477 8 15 8H19"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M5 8V5C5 3.89543 5.89543 3 7 3H14L19 8V19C19 20.1046 18.1046 21 17 21H12"
                      stroke="#585F74"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="6"
                      cy="14"
                      r="3"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="6"
                      cy="14"
                      r="3"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.5 17L3 22L6 20.5L9 22L7.5 17"
                      stroke="#4B465C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.5 17L3 22L6 20.5L9 22L7.5 17"
                      stroke="white"
                      strokeOpacity="0.2"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
                <span className="menu-text">
                  <FormattedMessage id="menu.certificate" />
                </span>
              </NavLink>
            </li>
          </>
        ) : null}
      </ul>
    </>
  );
}
